module.exports = __webpack_public_path__ + "static/media/document.459d73dd.svg";